import axios from "axios";
import type { Translations_GetTranslations_GetTranslationsQueryResponse_Success } from "./swagger-types/v1/index.js";
import { commonResponsesTypeGuards } from "./common-responses-type-guards.js";
import { getAppConfiguration } from "@holisto-web/config";
import { selectLocaleCode } from "@modules/languages";

export const TRANSLATIONS_LOCALE_FILE_PATTERN = /\/(?<localeCode>[a-z]{2}-[A-Z]{2})\.json$/;

export const getTranslationsUrl = (languageCode: ILanguage, countryCode: string): string => {
  const { translationsPath } = getAppConfiguration();
  return `${translationsPath}/${selectLocaleCode(languageCode, countryCode)}.json`;
};

const getTranslations = async (
  languageCode: ILanguage,
  countryCode: string,
): Promise<Translations_GetTranslations_GetTranslationsQueryResponse_Success> => {
  const response = await axios.get<
    Translations_GetTranslations_GetTranslationsQueryResponse_Success | Record<string, unknown>
  >(getTranslationsUrl(languageCode, countryCode));

  const data = response.data;

  if (data && typeof data === "object" && "translations" in data && data.translations != null) {
    return { translations: data.translations as Record<string, unknown> };
  }

  return { translations: data as Record<string, unknown> };
};
const getTranslationGuards = { ...commonResponsesTypeGuards };
getTranslations.guards = getTranslationGuards;

export const translationsApi = { getTranslations: getTranslations } as const;
